import "./Avaliacao.css"

export default function Avaliacao({nota}) {
    if (!nota) return <></>
    return <div data-testid='avaliacao' className="avaliacao" title={`Avaliação da pessoa: ${nota} estrela${nota > 1 ? 's' : ''}`}>
        <span className="estrelaAtiva">{"★".repeat(nota)}</span>
        <span className="estrelaInativa">{"★".repeat(5 - nota)}</span>
    </div>
}